import React from 'react';
import { Alert as RsAlert } from 'reactstrap';
import PropTypes from 'prop-types';
import Translate from './Translate';

const Alert = ({ color, visible, hideOfflineAlert, children }) => (
  <RsAlert
    color={color}
    isOpen={visible}
    toggle={hideOfflineAlert}
    fade={false}
    className={children.length < 70 ? '' : 'alert-2-rows'}
  >
    <Translate code={children} />
  </RsAlert>
);

export default Alert;
Alert.propTypes = {
  color: PropTypes.oneOf(['warning', 'success', 'danger']).isRequired,
  visible: PropTypes.bool.isRequired,
  hideOfflineAlert: PropTypes.func.isRequired,
  children: PropTypes.string.isRequired,
};
